import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Grid,
  Card,
  BottomNavigation,
  BottomNavigationAction,
  Avatar,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Home as HomeIcon,
  Checklist as ChecklistIcon,
  Timer as TimerIcon,
  NotificationsActive as NotificationsActiveIcon,
  ExitToApp as ExitToAppIcon,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";

const user = JSON.parse(localStorage.getItem("user"));

const InstructorHome = () => {
  const navigate = useNavigate();

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("CC_Token");
    localStorage.removeItem("user");
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    });
    setTimeout(() => navigate("/login"), 4000);
  };

  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs");
  };

  const handleProfile = () => {
    user.role === "admin" ? navigate("/ProfileAdmin") : navigate("/Profile");
  };

  return (
    <div className="app">
      {/* Toast Container */}
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src={"../assets/cej.png"}
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box
        sx={{
          padding: "0.5rem",
          marginTop: "64px", // Espace sous le header
          backgroundColor: "#e0f7fa",
          height: "calc(100vh - 64px - 64px)", // 100vh - Header - Footer
          overflowY: "auto", // Permet le scroll interne si nécessaire
        }}
      >
        {/* Image principale */}
        <Card
          sx={{
            marginBottom: "1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "transparent",
            boxShadow: "none",
          }}
        >
          <img
            src={"../assets/ja.jpg"}
            alt="Club Équestre Jafoura"
            style={{
              width: "99%",
              borderRadius: "0px",
              height: "150px",
              objectFit: "cover",
            }}
          />
        </Card>

        {/* Menu Items */}
        <Grid container spacing={1}>
          {[
            { path: "/AdminChrono", icon: <TimerIcon sx={{ fontSize: 20, color: "#f57c00" }} />, text: "Changement du temps", bgColor: "#fff3e0" },
            { path: "/InstructorChecklist", icon: <ChecklistIcon sx={{ fontSize: 20, color: "#f57c00" }} />, text: "Checklist", bgColor: "#fff3e0" },
            { path: "/ApprouverClientInstructor", icon: <ChecklistIcon sx={{ fontSize: 20, color: "#f57c00" }} />, text: "Assigner Client", bgColor: "#fff3e0" },
            { path: "/AdminNotificationToClient", icon: <NotificationImportantIcon sx={{ fontSize: 20, color: "#d32f2f" }} />, text: "Envoyer une notification personnalisée", bgColor: "#ffebee" },
            { path: "/AdminNotification", icon: <NotificationsActiveIcon sx={{ fontSize: 20, color: "#d32f2f" }} />, text: "Notifications", bgColor: "#ffebee" },
            
          ].map((item, index) => (
            <Grid item xs={12} key={index}>
              <Card
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "1rem",
                  cursor: "pointer",
                  backgroundColor: item.bgColor,
                  borderRadius: "8px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    backgroundColor: item.bgColor === "#fff3e0" ? "#ffe0b2" : "#ffcdd2",
                  },
                }}
                onClick={() => navigate(item.path)}
              >
                {item.icon}
                <Typography variant="h6" sx={{ marginLeft: "1rem", fontSize: "1.2rem", flexGrow: 1, color: item.icon.props.sx.color }}>
                  {item.text}
                </Typography>
                <MenuIcon sx={{ fontSize: 20, color: item.icon.props.sx.color }} />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminChrono")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/InstructorHome")}
          />
          <BottomNavigationAction
            label="Checklist"
            icon={<ChecklistIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/InstructorChecklist")}
          />
        </BottomNavigation>
      </Box>
    </div>
  );
};

export default InstructorHome;